'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const HeroSection = () => {
  const scrollToBooking = () => {
    const bookingSection = document.getElementById('booking-calendar');
    bookingSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative bg-gradient-to-br from-primary via-primary to-secondary py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-8">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-semibold text-white">Enterprise AI Transformation</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-headline text-white mb-6 leading-tight">
            AI Success is a Leadership Problem,
            <span className="block text-accent mt-2">Not a Technology Problem</span>
          </h1>

          <p className="text-xl md:text-2xl text-white/90 font-body mb-8 leading-relaxed">
            Book a discovery call to explore how proven change management frameworks can transform your AI investment into measurable business outcomes.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <button
              onClick={scrollToBooking}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-semibold font-cta text-base text-primary bg-white hover:bg-white/90 transition-all duration-300 shadow-strong hover:shadow-xl hover:-translate-y-0.5 w-full sm:w-auto"
            >
              Schedule Discovery Call
              <Icon name="CalendarIcon" size={20} variant="solid" />
            </button>
            <a
              href="#value-proposition"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-lg font-semibold font-cta text-base text-white border-2 border-white hover:bg-white hover:text-primary transition-all duration-300 w-full sm:w-auto"
            >
              Learn More
              <Icon name="ArrowDownIcon" size={20} variant="solid" />
            </a>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">85%</div>
              <div className="text-sm text-white/80">Success Rate</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">6-12</div>
              <div className="text-sm text-white/80">Months to ROI</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">200+</div>
              <div className="text-sm text-white/80">Transformations</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-white mb-1">$50M+</div>
              <div className="text-sm text-white/80">Value Created</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;